class InterfaceBuilder {
    static createInterface(methods) {
        return class Interface {
            constructor() {
                if (new.target === Interface) {
                    throw new Error('Interfaces could not be instantiated');
                }

                methods.forEach((method) => {
                    if (Reflect.getPrototypeOf(this)[method] === Reflect.getPrototypeOf(Interface)[method]) {
                        throw new Error(`You must implement ${method} method`);
                    }
                });
            }
        }
    }
}

export {InterfaceBuilder};